export default __webpack_public_path__ + "static/AseoInd_4-fcfa3d24460d8cf7bcf4c800151a42ce.png";